const plain = {
  color: "inherit",
  textDecoration: "none",
  ":focus": {
    variant: "focus",
  },
};

export { plain };
